<template>
    <div class="runningText" v-html="text"></div>
</template>

<script>
export default {
  name: 'RunningText',
  props: ["text"]
}
</script>

<style lang="scss" scoped>
  .runningText {
    text-align: left;
  }
</style>